class MFRFAQ {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      section: ".mfr-core__faq",
      links: "li a",
    };

    this.init();
  }

  init() {
    this.$section = $(this.selectors.section);
    this.$links = this.$element.find(this.selectors.links);

    this.resizeFAQFilters();
    this.initializeActiveLinksChanging();
    $(window).on("resize", this.resizeFAQFilters.bind(this));
    this.$links.on("click", this.__handleLinksClick.bind(this));
  }

  __handleLinksClick( e ) {
    this.$links.removeClass("is-active");
    $(e.currentTarget).addClass("is-active");
  }

  resizeFAQFilters() {
    if ($(window).width() >= 1024) {
      const firstFAQOffset = $(this.$section.get(0)).offset().top;

      //give elem offset top and decrease height
      this.$element.css({
        top: firstFAQOffset,
        height: this.$element.height() - firstFAQOffset,
      });
    } else {
      this.$element.css("height", "");
    }
  }

  initializeActiveLinksChanging() {
    this.$section.each(( i, section ) => {
      ScrollTrigger.create({
        trigger: section,
        start: "top center",
        onEnter: () => {
          const link = this.$element.find(
            `${this.selectors.links}[href="#${$(this.$section.get(i)).attr(
              "id"
            )}"]`
          );
          if (link.length) {
            this.$links.removeClass("is-active");
            link.addClass("is-active");
          }
        },
        onLeaveBack: () => {
          const link = this.$element.find(
            `${this.selectors.links}[href="#${$(this.$section.get(i-1)).attr(
              "id"
            )}"]`
          );
          if (link.length) {
            this.$links.removeClass("is-active");
            link.addClass("is-active");
          }
        }
      });
    });
  }
}